/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('UtpTestServiceApi', ($http, ApiErrorService) => {
    return {
        getTestInfo: getTestInfo,
        getTestIdNameResponse: getTestIdNameResponse,
        importTestCaseInstructions: importTestCaseInstructions
    };
    function getTestInfo(testId) {
        return $http.get(`api/UtpTest/GetTestInfo?testId=${testId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTestIdNameResponse(testId) {
        return $http.get(`api/UtpTest/GetTestIdNameResponse?testId=${testId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function importTestCaseInstructions(testSuiteId, userId) {
        return $http.post(`api/UtpTest/ImportTestCaseInstructions?testSuiteId=${testSuiteId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
